import { useTranslation } from "@coworker/locales";

function MfaqUpvotesGraph() {
  const { t } = useTranslation();

  return (
    <svg
      viewBox="-15 -22 374 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%" }}
    >
      {/* Axis labels */}
      <text
        transform="translate(-5, 40) rotate(-90)"
        textAnchor="middle"
        fontSize={11}
        fill="#CCCCCC"
      >
        {t("mfaqGraphUpvotesLabel")}
      </text>
      <text x={15} y={97} textAnchor="start" fontSize={11} fill="#CCCCCC">
        {t("mfaqGraphTimeLabel")}
      </text>

      {/* Marker labels */}
      <text x={88.2} y={-7} textAnchor="middle" fontSize={12} fill="black">
        {t("mfaqGraphTaskCreatedLabel")}
      </text>
      <text x={211.7} y={-7} textAnchor="middle" fontSize={12} fill="black">
        {t("mfaqGraphTaskCompletedLabel")}
      </text>

      {/* Area fill before task created */}
      <path
        d="M18.1918 67.4983L2.75586 77.4983H211.692V21.5L204.525 25L198.461 27.9983L190.743 25.4983L179.717 27.9983H126.243L107.499 32.4983L87.102 46.9983L67.8072 55.9983L38.5892 64.9983L18.1918 67.4983Z"
        fill="url(#mfaq-paint0)"
      />

      {/* Dashed line - task created */}
      <path
        d="M88.2051 70.5L88.2051 0.499996"
        stroke="#DFDFDF"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />

      {/* Dashed line - task completed */}
      <path
        d="M211.693 18.5L211.693 0.499999"
        stroke="#DFDFDF"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />

      {/* Area fill after task completed */}
      <path
        d="M232.641 75.5L217.205 77.5H341.244V75.5H330.218L320.295 72.5L316.436 75.5L302.654 72.5L294.936 75.5L283.91 72.5L275.09 75.5L265.167 72.5L250.833 65L243.115 67.5L232.641 75.5Z"
        fill="url(#mfaq-paint1)"
      />

      {/* Main chart line */}
      <path
        d="M2.20508 77.5L18.1923 67L38.5897 64.5L67.8076 55.5L87.1025 46.5L107.5 32L126.244 27.5H153.256H179.718L190.744 25L198.462 27.5L212.244 21V77.5L232.641 75L243.115 67L250.833 64.5L265.167 72L275.09 75L283.91 72L294.936 75L302.654 72L316.436 75L320.295 72L330.218 75H341.244"
        stroke="#0058A3"
      />

      {/* X-axis bar */}
      <rect y={77.5} width={344} height={6} rx={3} fill="#DFDFDF" />

      {/* Task created marker */}
      <g filter="url(#mfaq-filter0)">
        <mask id="mfaq-mask0" fill="white">
          <ellipse cx={88.2072} cy={80.5} rx={6.61539} ry={6} />
        </mask>
        <ellipse cx={88.2072} cy={80.5} rx={6.61539} ry={6} fill="white" />
        <path
          d="M94.8226 80.5H85.8226C85.8226 79.3698 86.3465 78.5225 86.8386 78.0762C87.3164 77.6428 87.8248 77.5 88.2072 77.5V86.5V95.5C95.9843 95.5 103.823 89.591 103.823 80.5H94.8226ZM88.2072 86.5V77.5C88.5896 77.5 89.0979 77.6428 89.5757 78.0762C90.0679 78.5225 90.5918 79.3698 90.5918 80.5H81.5918H72.5918C72.5918 89.591 80.43 95.5 88.2072 95.5V86.5ZM81.5918 80.5H90.5918C90.5918 81.6302 90.0679 82.4775 89.5757 82.9238C89.0979 83.3572 88.5896 83.5 88.2072 83.5V74.5V65.5C80.43 65.5 72.5918 71.409 72.5918 80.5H81.5918ZM88.2072 74.5V83.5C87.8248 83.5 87.3164 83.3572 86.8386 82.9238C86.3465 82.4775 85.8226 81.6302 85.8226 80.5H94.8226H103.823C103.823 71.409 95.9843 65.5 88.2072 65.5V74.5Z"
          fill="#484848"
          mask="url(#mfaq-mask0)"
        />
      </g>

      {/* Task completed marker */}
      <g filter="url(#mfaq-filter1)">
        <mask id="mfaq-mask1" fill="white">
          <ellipse cx={211.692} cy={80.5} rx={6.61539} ry={6} />
        </mask>
        <ellipse cx={211.692} cy={80.5} rx={6.61539} ry={6} fill="white" />
        <path
          d="M218.307 80.5H209.307C209.307 79.3698 209.831 78.5225 210.323 78.0762C210.801 77.6428 211.309 77.5 211.692 77.5V86.5V95.5C219.469 95.5 227.307 89.591 227.307 80.5H218.307ZM211.692 86.5V77.5C212.074 77.5 212.582 77.6428 213.06 78.0762C213.552 78.5225 214.076 79.3698 214.076 80.5H205.076H196.076C196.076 89.591 203.914 95.5 211.692 95.5V86.5ZM205.076 80.5H214.076C214.076 81.6302 213.552 82.4775 213.06 82.9238C212.582 83.3572 212.074 83.5 211.692 83.5V74.5V65.5C203.914 65.5 196.076 71.409 196.076 80.5H205.076ZM211.692 74.5V83.5C211.309 83.5 210.801 83.3572 210.323 82.9238C209.831 82.4775 209.307 81.6302 209.307 80.5H218.307H227.307C227.307 71.409 219.469 65.5 211.692 65.5V74.5Z"
          fill="#0A8A00"
          mask="url(#mfaq-mask1)"
        />
      </g>

      <defs>
        <filter
          id="mfaq-filter0"
          x={65.5918}
          y={62.5}
          width={45.2305}
          height={44}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={8} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="mfaq-filter1"
          x={189.076}
          y={62.5}
          width={45.2305}
          height={44}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={8} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="mfaq-paint0"
          x1={108.051}
          y1={80}
          x2={108.681}
          y2={22.4985}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFCFC" stopOpacity={0.75} />
          <stop offset={1} stopColor="#1B486E" stopOpacity={0.35} />
        </linearGradient>
        <linearGradient
          id="mfaq-paint1"
          x1={281.154}
          y1={77.5}
          x2={280.099}
          y2={54.0226}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFCFC" stopOpacity={0.75} />
          <stop offset={1} stopColor="#1B486E" stopOpacity={0.35} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MfaqUpvotesGraph;
